import WinController from './winController';
import SoundManager from 'Engine/soundManager/SoundManager';
import { gsap } from 'gsap';
import EntryPoint from 'Engine/EntryPoint';

export default class SmallWinController extends WinController {
  constructor(props) {
    super(props);
  }

  onStart() {
    if (this.ControllerPopup.stack.length) {
      this.setDurationOnNextCall(4000);
      this.setCounterOffsetOnNextCall(0);
    } else {
      this.setDurationOnNextCall(EntryPoint.GameModel.winnings.lines.length * this._config.duration);
    }

    this.ControllerPopup.stopMainBackgroundSound();
  }

  cleanup() {
    super.cleanup();
    const sound = SoundManager.getSound(this._config.sound.soundName);
    gsap.to(sound, { volume: 0, duration: 0.5, onComplete: () => sound.stop()});

    this.ControllerPopup.playMainBackgroundSound();
  }
}
